import type { NativeEventName, NativeEventPayload } from './nativeEvents'
import { reportError } from './error'

/**
 * Global bridge for iOS native app to send events to the web app.
 *
 * iOS calls: window.nativeEventBridge.receive('eventName', payload)
 * React listens: useNativeEventListener(handler)
 */

window.nativeEventBridge = window.nativeEventBridge || {
  receive<T extends NativeEventName>(eventName: T, payload: NativeEventPayload<T>) {
    if (typeof window.onNativeEvent === 'function') {
      try {
        window.onNativeEvent(eventName, payload)
      } catch (e) {
        reportError(e, {
          severity: 'warning',
          metaData: { eventName, payload, context: 'native event bridge' },
        })
      }
    }
  },
}
